"use strict";

exports.__esModule = true;

var videoplayer_api_client_1 = require("@svt/videoplayer-api-client");

var __1 = require("..");

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");
/**
 * Determine if a stream info should be retried (fetched again).
 * A stream info with secondsToLiveRetry specified, is an indication from the
 * API that the stream has not started yet and that its video references
 * are not yet available.
 */


exports.shouldLiveRetry = function (streamInfo) {
  return streamInfo.secondsToLiveRetry !== null && streamInfo.secondsToLiveRetry >= 0 && Object.keys(streamInfo.videoReferences).length === 0;
};
/*
 * Returns an observable of StreamInfo that is refreshed as long as it is
 * suggested by the shouldLiveRetry function.
 */


exports.liveRetryStreamInfo = function (streamInfo) {
  var videoId = streamInfo.videoId,
      secondsToLiveRetry = streamInfo.secondsToLiveRetry;

  if (secondsToLiveRetry === null) {
    throw new __1.PlayerError('Cannot live try streamInfo if secondsToLiveRetry is null');
  }

  var liveRetry$ = new rxjs_1.BehaviorSubject(secondsToLiveRetry);
  return liveRetry$.pipe(operators_1.map(function (liveRetry) {
    return liveRetry > 0 ? liveRetry : 10;
  }), operators_1.switchMap(function (liveRetry) {
    return rxjs_1.timer(liveRetry * 1000);
  }), operators_1.switchMap(function () {
    return videoplayer_api_client_1.fetchStreamInfo(videoId);
  }), operators_1.tap(function (streamInfo) {
    if (exports.shouldLiveRetry(streamInfo) && streamInfo.secondsToLiveRetry !== null) {
      liveRetry$.next(streamInfo.secondsToLiveRetry);
    }
  }));
};